//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  model: {
    event: 'input',
    prop: 'value'
  },
  props: {
    placeholder: {
      type: String,
      default: () => 'Chose range'
    },
    value: {
      type: [Array, String],
      default: () => []
    },
    bordered: {
      type: Boolean,
      default: () => false
    },
    step: {
      type: Array,
      default: () => [1000, 10000]
    },
    dollar: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      active: false,
      title: '',
      localValue: [],
      showSpin: false,
      maxMin: 0,
      minMin: 0
    }
  },
  created () {
    if (this.value.length > 0) {
      this.localValue = this.value
    } else {
      this.title = this.placeholder
    }

    if (process.client) {
      document.addEventListener('click', this.documentClick)
    }

    if (this.localValue.length) {
      this.title = `${this.value[0]} - ${this.value[1]}`
    }
  },
  destroyed () {
    if (process.client) {
      document.removeEventListener('click', this.documentClick)
    }
  },
  methods: {
    handleClick (e) {
      this.active = !this.active
    },
    handleInput (e, idx) {
      this.localValue[idx] = e.target.value
      this.maxMin = this.localValue[0]
      if (this.localValue[0] > this.localValue[1]) {
        return false
      }
      this.title = this.localValue.join(' - ')
      this.$emit('input', this.localValue)
    },
    documentClick (e) {
      let rangeSelect = this.$refs.rangeSelect
      let rangeMenu = this.$refs.rangeSelectMenu
      let target = e.target
      try {
        if ((rangeSelect !== target && !rangeSelect.contains(target))) {
          if (rangeMenu !== target && !rangeMenu.contains(target)) {
            this.active = false
          }
        }
      } catch (e) {
        // @TODO need fix
      }
    }
  }
}
